// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 校验用户服务权限 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /vip/permission/check */
export async function vipPermissionCheckUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.vipPermissionCheckUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultboolean>('/vip/permission/check', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户已开通的服务详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /vip/service/list */
export async function vipServiceListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.vipServiceListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVipServiceInfo>('/vip/service/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
